const addUpdateMessage = ({ data, messages }) => {
    const { score, option, userInfo } = data;



    const newMessages = [...messages];


    const item = newMessages.find(m => m.score === score);

    if (item) {




        if (item?.score) {

            if (option === 'status') {

                if (!item?.status) {
                    item.status = 1;
                    console.log('pegou aqui')
                }
                else {

                    item.status = item?.status === 2 ? 1 : 2;

                }
            }
            else if (item?.[option]?.[userInfo.id]) {
                console.log('aqui')
                delete item?.[option]?.[userInfo.id];
            }
            else {
                console.log('aqui2')
                console.log(item);
                if (!item?.[option]) {
                    item[option] = {};
                }
                item[option][userInfo.id] = userInfo.name;
            }




        }


    }

    return newMessages;
}

export default addUpdateMessage;